<form class="proto-input-form" novalidate
  [formGroup]="editForm"
  [ngClass]="{ 'is-disabled': isLoading }">

  @for (list of formFieldLists; track list.id) {

    <!-- display filter buttons after meta informations -->
    @if (list.id === 'general' && formCategories.length > 1) {
      <div class="form-categories">
        @for (category of formCategories; track category) {
          <ion-button [fill]="selectedCategory === category ? 'solid' : 'outline'" class="proto-button form-category-button"
            (click)="selectedCategory = category">
            {{ ('FORM.CATEGORY.' + category.toUpperCase()) | translate }}
          </ion-button>
        }
      </div>
    }

    @if (selectedCategory === 'all' || !list.category || list.category === selectedCategory) {
      @if (list.type === 'dynamic') {
        @for (item of list.items; track item.id) {
          @let control = asFormArray(item.id);
          <proto-dynamic-form-field
            [field]="item"
            [formArray]="control"
            [values]="dynamicFields[item.id]"></proto-dynamic-form-field>
        }
      } @else {
        @if (list.title) {
          <div class="proto-list-note proto-list-note--inset is-top">{{ list.title | translate }}</div>
        }
        <ion-list class="proto-input-list" inset>
          @for (item of list.items; let i = $index; track item.id) {

            <!-- dynamic fields are already part of dynamic fieldset -->
            @if (item.type !== 'dynamic') {
              @let control = asFormControl(item.id);
              <proto-form-field
                [control]="control"
                [field]="item"></proto-form-field>
            }
          }
        </ion-list>
      }
    }

  }

  @if (editForm.hasError('personNameRequired') && editForm.dirty) {
    <div class="proto-list-note proto-list-note--inset">
      {{ 'FORM.PERSON_NAME_ERROR_TEXT' | translate }}
    </div>
  }

  <div class="footer-content">
    <ion-button class="proto-button" fill="outline" color="dark" 
      [skipDialog]="!formIsValid()"
      (confirm)="processCompleted.emit('canceled')">
      {{ 'BUTTON.CANCEL' | translate }}
    </ion-button>

    <ion-button class="proto-button submit-button"
      [disabled]="!formIsValid() || isLoading"
      (click)="submit()">
      @if (isEditMode) {
        {{ 'BUTTON.SAVE' | translate }}
      } @else {
        {{ 'BUTTON.CREATE' | translate }}
      }
    </ion-button>
  </div>

</form>
